<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 40 40" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g><path d="M27.4.8H12.6C5.9.8.5 6.3.5 12.9V27c0 6.7 5.4 12.1 12.1 12.1h14.8c6.7 0 12.1-5.4 12.1-12.1V12.9C39.5 6.3 34.1.8 27.4.8zm9.1 26.3c0 5-4.1 9.1-9.1 9.1H12.6c-5 0-9.1-4.1-9.1-9.1v-.8c2.7 2.3 7.5 4.9 15.9 4.9h.2c3.4 0 7.5-1.5 7.7-5.5.2-4.2-3.8-5.6-7-6.7-2.7-.9-4.4-1.6-4.6-2.8-.1-.9-.1-2.1.5-2.9.5-.6 1.4-.9 2.8-.9s2.7.3 4.3 1.1c.7.4 1.6.1 2-.7.4-.7.1-1.6-.7-2-2-1-3.8-1.5-5.7-1.4-2.2.1-3.8.7-4.9 2-1.6 1.9-1.4 4.4-1.3 5.2.3 3.2 3.6 4.4 6.6 5.4 3.2 1.1 5.1 1.9 5 3.7-.1 2.6-4.2 2.7-4.7 2.7C7.9 28.2 4.2 23 3.5 21.8V13c0-5 4.1-9.1 9.1-9.1h14.8c5 0 9.1 4.1 9.1 9.1v14.1z" data-follow-fill="currentColor" :fill="_fill" /></g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
